import { render, staticRenderFns } from "./TableContactList.vue?vue&type=template&id=1031a68a&scoped=true"
import script from "./TableContactList.vue?vue&type=script&lang=js"
export * from "./TableContactList.vue?vue&type=script&lang=js"
import style0 from "./TableContactList.vue?vue&type=style&index=0&id=1031a68a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031a68a",
  null
  
)

export default component.exports